module.exports = __webpack_public_path__ + "img/Blog-Image.397d0813.png";